<div class="memory-indicator" *ngIf="memoryUsage$ | async as memoryUsage">
  <div id="label">MEMORY</div>
  <div id="percentage">{{ memoryUsage }}%</div>
</div>
